<template >
   <div>
           <div class="main-list-wrap pad20">
            <assignVerifier :ref="'assign_verifier'" v-if="caseDetails && [51].indexOf(getUserRoleId)>-1 && (checkProperty(caseDetails, 'authroizedRepresent')&&checkProperty(caseDetails, 'assignVerifier'))" @reloadPetition="reloadPetition" :caseDetails="caseDetails"/>
            <formI_9Section v-if="checkProperty(caseDetails, 'signedDocument', 'length') > 0" @reloadPetition="updatePetition" :caseDetails="caseDetails"/>
            <div>
              <h3 class="title-header">Employee Information</h3>
              <div class="vx-row m-0 main-list-panel">
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'beneficiaryInfo','firstName')">
                  <div class="main-list">
                    <p>First Name<span>{{caseDetails.beneficiaryInfo.firstName}}</span></p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'beneficiaryInfo','middleName')">
                  <div class="main-list">
                    <p>Middle Name<span>{{caseDetails.beneficiaryInfo.middleName}}</span></p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'beneficiaryInfo','lastName')">
                  <div class="main-list">
                    <p>Last Name<span>{{caseDetails.beneficiaryInfo.lastName}}</span></p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'beneficiaryInfo','otherLastName')">
                  <div class="main-list">
                    <p>Other Last Names Used<span>{{caseDetails.beneficiaryInfo.otherLastName}}</span></p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'beneficiaryInfo', 'dateOfBirth') ">
                  <div class="main-list">
                    <p>Date of Birth
                        <span>
                            {{ caseDetails.beneficiaryInfo.dateOfBirth | formatDate}}
                        </span>
                    </p>
                  </div>
                </div>
                <!-- v-if="checkProperty(caseDetails, 'beneficiaryInfo','SSN')" -->
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'beneficiaryInfo','SSN') || checkProperty(caseDetails, 'beneficiaryInfo','hasSSN')">
                  <div class="main-list">
                    <p>Social Security Number
                      <span>
                        <template v-if="checkProperty(caseDetails, 'beneficiaryInfo','hasSSN')">N/A</template>
                        <template v-else-if="checkProperty(caseDetails, 'beneficiaryInfo','SSN')"> {{caseDetails.beneficiaryInfo.SSN}} </template>
                        
                      </span>
                    
                    </p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0"
                v-if="checkProperty(caseDetails, 'beneficiaryInfo', 'phone') && 
                      checkProperty(caseDetails, 'beneficiaryInfo', 'phoneCountryCode') && 
                      checkProperty(caseDetails.beneficiaryInfo.phoneCountryCode, 'countryCallingCode')">
                    <div class="main-list">
                      <p>
                        Phone Number
                        <span>
                        <template v-if="checkProperty(caseDetails.beneficiaryInfo ,'phoneCountryCode' ,'countryCallingCode')">{{checkProperty(caseDetails.beneficiaryInfo ,'phoneCountryCode' ,'countryCallingCode')+"&nbsp;"}}</template>
                        {{caseDetails.beneficiaryInfo.phone}}</span>
                      </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0">
                  <div class="main-list" v-if="checkProperty(caseDetails, 'beneficiaryInfo','email')">
                    <p>Email<span>{{caseDetails.beneficiaryInfo.email}}</span></p>
                  </div>
                </div>
                <!-- <div class="vx-col md:w-1/4 w-full p-0">
                  <div class="main-list">
                    <p>Fax Number<span>{{checkProperty(caseDetails, 'beneficiaryInfo','lastName')?caseDetails.beneficiaryInfo.SSN:'N/A'}}</span></p>
                  </div>
                </div> -->
                <!-- <div class="vx-col md:w-1/4 w-full p-0">
                  <div class="main-list">
                    <p>An alien authorized to work<span>{{checkProperty(caseDetails, 'beneficiaryInfo','lastName')?caseDetails.beneficiaryInfo.SSN:'N/A'}}</span></p>
                  </div>
                </div> -->
                <!-- <div class="vx-col md:w-1/4 w-full p-0">
                  <div class="main-list">
                    <p>Form I-94 Admission Number<span>{{checkProperty(caseDetails, 'beneficiaryInfo','lastName')?caseDetails.beneficiaryInfo.SSN:'N/A'}}</span></p>
                  </div>
                </div> -->
                <!-- <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'citizenshipInfo','passportNumber')">
                  <div class="main-list">
                    <p>Passport Number<span>{{caseDetails.citizenshipInfo.passportNumber}}</span></p>
                  </div>
                </div> -->
                <div class="vx-col w-full p-0"
                v-if=" checkProperty(caseDetails ,'beneficiaryInfo' ,'address' )  && 
                    (
                        checkProperty(caseDetails['beneficiaryInfo'] ,'address' ,'line1' )
                       || checkProperty(caseDetails['beneficiaryInfo']['address'] ,'locationDetails' ,'name' )
                       || checkProperty(caseDetails['beneficiaryInfo']['address'] ,'stateDetails' ,'name' )
                       || checkProperty(caseDetails['beneficiaryInfo']['address'] ,'countryDetails' ,'name' )
                    )">
                  <div class="main-list">
                    <p>Address<span v-html="$options.filters.addressformat(caseDetails.beneficiaryInfo.address)"></span></p>
                  </div>
                </div>
                <!-- <div class="vx-col md:w-1/4 w-full p-0">
                  <div class="main-list">
                    <p>I used a preparer or translator<span>{{checkProperty(caseDetails, 'beneficiaryInfo','lastName')?caseDetails.beneficiaryInfo.SSN:'N/A'}}</span></p>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="border" v-if="checkProperty(caseDetails, 'citizenshipInfo','citizenStatus')"></div>
            <div v-if="checkProperty(caseDetails, 'citizenshipInfo','citizenStatus')">
              <h3 class="title-header">Citizenship/Immigration Status</h3>
              <div class="vx-row m-0 main-list-panel">
                <div class="vx-col w-full p-0">
                  <div class="details-list">
                    <!-- <p>Employees Lorem ipsum dolor sit amet ,  consectetur adipiscing elit. Phasellus aliquet turpis vitae ipsum cursus, ut gravida diam commodo. Nunc id sapien in lorem feugiat eleifend sit amet sed massa</p> -->
                    <ul>
                      <li>{{getCitizenshipStatus(checkProperty(caseDetails, 'citizenshipInfo','citizenStatus'))}}</li>
                    </ul>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'citizenshipInfo', 'alienExpiryDate') || checkProperty(caseDetails, 'citizenshipInfo', 'hasExpiryDate')">
                  <div class="main-list">

                    <p>Expiration Date
                      <span>
                        <template v-if="checkProperty(caseDetails, 'citizenshipInfo', 'hasExpiryDate')">N/A</template>
                        <template v-else-if="checkProperty(caseDetails, 'citizenshipInfo', 'alienExpiryDate')"> {{caseDetails.citizenshipInfo.alienExpiryDate | formatDate}} </template>
                        
                      </span>
                    </p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'citizenshipInfo', 'USCISNumber')">
                  <div class="main-list">
                    <p>USCIS Number<span>{{checkProperty(caseDetails, 'citizenshipInfo', 'USCISNumber')}}</span></p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'citizenshipInfo', 'alienNumber')">
                  <div class="main-list">
                    <p>USCIS A-Number<span>{{checkProperty(caseDetails, 'citizenshipInfo', 'alienNumber')}}</span></p>
                  </div>
                </div> 
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'citizenshipInfo', 'i94AdmissionNo')">
                  <div class="main-list">
                    <p>Form I-94 Admission Number<span>{{checkProperty(caseDetails, 'citizenshipInfo', 'i94AdmissionNo')}}</span></p>
                  </div>
                </div> 
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'citizenshipInfo', 'passportNumber')">
                  <div class="main-list">
                    <p>Foreign Passport Number<span>{{checkProperty(caseDetails, 'citizenshipInfo', 'passportNumber')}}</span></p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'citizenshipInfo','passportIssuedCountryDetails')">
                  <div class="main-list">
                    <p>Country of Issuance<span>{{caseDetails.citizenshipInfo.passportIssuedCountryDetails.name}}</span></p>
                  </div>
                </div>  
              </div>
            </div>
            <div class="border" v-if="checkProperty(caseDetails,'beneficiaryInfo', 'usedPreparer')"></div>
            <div>
              <h3 class="title-header" v-if="checkProperty(caseDetails,'beneficiaryInfo', 'usedPreparer')">Preparer/Translator Certificate</h3>
              <div class="vx-row m-0 main-list-panel">
                <div class="vx-col w-full p-0" v-if="checkProperty(caseDetails,'beneficiaryInfo', 'usedPreparer')">
                  <div class="details-list">
                    <p>If a preparer and/or translator assisted you in completing Section 1, that person MUST complete the Preparer and/or Translator Certification</p>
                    <ul>
                      <li v-if="checkProperty(caseDetails,'beneficiaryInfo', 'usedPreparer')">A Preparer(s) and/or translator(s).</li>
                      <li v-else>I did not use.</li>
                    </ul>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'preparerInfo','firstName')">
                  <div class="main-list">
                    <p>First Name<span>{{caseDetails.preparerInfo.firstName}}</span></p>
                  </div>
                </div>
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'preparerInfo','middleName')">
                  <div class="main-list">
                    <p>Middle Name<span>{{caseDetails.preparerInfo.middleName}}</span></p>
                  </div>
                </div> 
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'preparerInfo','lastName')">
                  <div class="main-list">
                    <p>Last Name<span>{{checkProperty(caseDetails, 'preparerInfo','lastName')}}</span></p>
                  </div>
                </div> 
                <div class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(caseDetails, 'preparerInfo','email')">
                  <div class="main-list">
                    <p>Email<span>{{checkProperty(caseDetails, 'preparerInfo','email')}}</span></p>
                  </div>
                </div>
                <div class="vx-col w-full p-0"v-if=" checkProperty(caseDetails ,'preparerInfo' ,'address' )  && 
                    (
                        checkProperty(caseDetails['preparerInfo'] ,'address' ,'line1' )
                       || checkProperty(caseDetails['preparerInfo']['address'] ,'locationDetails' ,'name' )
                       || checkProperty(caseDetails['preparerInfo']['address'] ,'stateDetails' ,'name' )
                       || checkProperty(caseDetails['preparerInfo']['address'] ,'countryDetails' ,'name' )
                    )">
                  <div class="main-list">
                    <p>Address<span v-html="$options.filters.addressformat(caseDetails.preparerInfo.address)"></span></p>
                  </div>
                </div>
              </div>
            </div>
            
           </div>
           <!-- <div v-else>
            <div class="no-activities q_not_submitted">
            <div class="q_not_submitted_cnt">
              <figure>
                <img src="@/assets/images/main/no-activity-img.png" />
              </figure>
              <h3>
                <template>
                  <template>
                    <router-link
                      :to="{ name: 'Request I-9', params: { itemId: i9Id } }"
                    >
                      Fill Questionnaire.
                    </router-link></template
                  >
                </template>
              </h3>
            </div>
          </div> -->
            <!-- <NoDataFound  v-if='false':loading="false" :checkLocading="false" ref="NoDataRefd" content="" heading="No Data Found." type="documents" /> -->
            <!-- <assignVerifierModal ref="assignVerifierModalRef" /> -->
          </div>
      
</template>

   <script>
import NoDataFound from "@/views/common/noData.vue";
import formI_9Section from "./formI_9Section.vue"
import assignVerifier from "./assignVerifier.vue"
import assignVerifierModal from "@/views/i-9Module/assignVerifierModal.vue"


      export default {
          components: {
            NoDataFound,
            formI_9Section,
            assignVerifier,
            assignVerifierModal
           },
           mounted(){
              this.showVerifier = true
           },
           methods:{
            triggerAssignVerifer(){
              this.$refs['assign_verifier'].assignVerifier()
            },
            updatePetition(){
              this.$emit('reloadPetition')
            },
            reloadPetition(data){
              this.assignerDetails = data
              if(this.assignerDetails){
                this.employeeassignedVerifier()
              }
              this.showVerifier=false
            },

            employeeassignedVerifier(){
              let postData = {
                "i9Id": this.checkProperty(this.caseDetails, '_id'),
                "verifierType": this.checkProperty(this.caseDetails, 'verifierType'),
                }

                let obj = {
                  '_id' :this.checkProperty(this.assignerDetails,'_id'),
                  'customId':this.checkProperty(this.assignerDetails, 'customId'),
                  'name': this.checkProperty(this.assignerDetails, 'name'),
                  'email':this.checkProperty(this.assignerDetails, 'email'),
                  'alreadyExisted': this.checkProperty(this.assignerDetails, 'alreadyExisted'),
                  'phone':this.checkProperty(this.assignerDetails, 'phone'),
                  'phoneCountryCode': this.checkProperty(this.assignerDetails, 'phoneCountryCode'),
                  "tempUser":this.checkProperty(this.assignerDetails,'tempUser')
                }
                postData['verifierInfo'] = obj
                postData['verifierId'] = obj['_id']
                postData['authroizedRepresent'] =false
                postData['chooseVerifyAndSign'] =false
                let path = '/i9/assign-verifier'
              this.$store.dispatch('commonAction', ({'data':postData, 'path':path})).then((response)=>{
                this.showToster({message:response.message ,isError:false});
                this.$emit('reloadPetition')
                // this.loadingRequest = false;
                // setTimeout(()=>{
                //       this.closeAssignVerifierPopUp();
                //   },1000)
              }).catch((err)=>{
                    this.showToster({message:error,isError:true });
                    // this.requestErr = err;
                    // this.loadingRequest = false;
                })
            },



            getCitizenshipStatus(status){
                if(status=='citizen_us'){
                  return 'A citizen of the United States'
                }else if(status=='non_citizen_us'){
                  return 'A noncitizen other than (Lorem ipsum dolor sit amet, consectetur adipiscing elit.)'
                }else if(status=='lawful_perm_resident'){
                    return 'A lawful permanent resident'
                }else if(status=='alien_auth_work'){
                    return 'An alien authorized to work'
                }else{
                    return ''
                }
            }
           },
           data: () => ({
            showVerifier:false,
            assignerDetails:null,
           }),
           props: {
            caseDetails: {
                type: Object,
                default: null
            },
            i9Id: {
              default: null
            },
           
        },
       }
   </script>